export default {"src":"/customer-services/_next/static/media/instore.c4ab210e.svg","height":35,"width":35,"blurWidth":0,"blurHeight":0};